// Texts of the perimeter field of the mission creation live under this key.
export const MISSION_PERIMETER_TEXT_ROOT = 'createMission.perimeter';

export const missionPerimeterText = (language, key) =>
  language.getValue(`${MISSION_PERIMETER_TEXT_ROOT}.${key}`, '');

// The field only exists for a company with active perimeters: without it, the
// mission body stays exactly what it was before perimeters.
export const isMissionPerimeterFieldShown = (field) =>
  field.status === 'ready' && field.perimeters.length > 0;

// perimeterId is only sent when the field is shown; null means « Aucun
// périmètre », which the api reads as visible to every manager.
export const withMissionPerimeter = (payload, field) => {
  const rest = { ...payload };
  delete rest.perimeterId;
  if (!isMissionPerimeterFieldShown(field)) return rest;
  return { ...rest, perimeterId: field.perimeterId ?? null };
};

const MISSION_PERIMETER_ERROR_KEYS = {
  INVALID_PERIMETER_ID: 'errors.notFound',
  PERIMETER_NOT_FOUND: 'errors.notFound',
  PERIMETER_ARCHIVED: 'errors.archived',
};

// The text of a refusal caused by the chosen perimeter, or null when the
// refusal is about something else.
export const getMissionPerimeterErrorMessage = (language, err) => {
  const key = MISSION_PERIMETER_ERROR_KEYS[err?.response?.data?.errorCode];
  return key ? missionPerimeterText(language, key) : null;
};
